import { Icon } from 'types/Icon';

export const IconSelectableIOS = ({ ...restProps }: Icon) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path
      d="M8.17 18a1.5 1.5 0 0 1-1.2-.63l-4.6-5.82a1.73 1.73 0 0 1-.29-.46A1.42 1.42 0 0 1 2 10.6a1.22 1.22 0 0 1 1.25-1.26c.41 0 .75.18 1.03.54l3.86 5.02 7.52-12.24c.16-.25.32-.42.48-.51.17-.1.38-.16.63-.16A1.2 1.2 0 0 1 18 3.23c0 .15-.02.3-.07.44-.05.15-.12.3-.22.46l-8.32 13.2c-.28.45-.69.67-1.22.67Z"
      fill="currentColor" />
  </svg>
);
